// extracted by mini-css-extract-plugin
export default {"erro":"PaginaDeErro_erro__NFNh4","erro__BtnErro":"PaginaDeErro_erro__BtnErro__m+m3s"};